// src/views/source-connections/components/wizard/forms/CsvUploadForm.jsx

import React, { useRef } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import "filepond/dist/filepond.min.css";
import { Dropdown } from "../../../../../components/form-components/Dropdown";

registerPlugin(FilePondPluginFileValidateType);

const CsvUploadForm = ({ sourceType, formData, onChange }) => {
  const filePondRef = useRef(null);

  const providerField = sourceType.fields.find((f) => f.name === "associated_provider");

  const handleFileUpdate = (fileItems) => {
    if (fileItems.length === 0) {
      onChange({ ...formData, file: null });
      return;
    }
    onChange({ ...formData, file: fileItems[0].file });
  };

  return (
    <div>
      {providerField && (
        <div className="mb-5">
          <label className="block text-sm font-medium text-text-2 mb-2">{providerField.label}</label>
          <Dropdown
            options={providerField.options.map((o) => ({ value: o.value, label: o.label }))}
            selectedValue={providerField.options.find((o) => o.value === (formData.associated_provider || providerField.options[0].value)) || providerField.options[0]}
            setSelectedValue={(val) => onChange({ ...formData, associated_provider: val.value })}
            dropdownWidth={400}
          />
          <p className="text-xs text-text-2 mt-1">Link this upload to a provider for cost categorization.</p>
        </div>
      )}

      <div className="mb-5">
        <label className="block text-sm font-medium text-text-2 mb-2">Upload File</label>
        <FilePond
          ref={filePondRef}
          allowMultiple={false}
          maxFiles={1}
          credits={false}
          instantUpload={false}
          acceptedFileTypes={[
            "text/csv",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/pdf",
          ]}
          onupdatefiles={handleFileUpdate}
          labelIdle='<span class="text-sm text-text-2">Drop CSV or invoice file here or <span class="filepond--label-action">browse</span></span>'
        />
      </div>

      <div className="flex items-start gap-2.5 p-3 bg-surface-2 border border-border rounded-ctrl text-xs text-text-2">
        <span className="text-primary mt-0.5">ℹ</span>
        <span>Manual sources do not create an automated import schedule. You can upload new files at any time from the connection detail page.</span>
      </div>
    </div>
  );
};

export default CsvUploadForm;
